export default {
  slug: null,
  items: 8,
}
